<template>
    <div class="bg-white p-6 shadow-md">
        <h2 class="text-xl font-semibold text-gray-800 mb-4 flex items-center">
            <span class="mr-2">🏫</span>
            <span>Location Type Distribution</span>
        </h2>
        <apexchart class="flex justify-center items-center" type="pie" width="350" :options="chartOptions"
            :series="series"></apexchart>
    </div>
</template>

<script>
export default {
    name: "LocationTypeDistribution",
    props: ["data"],
    data() {
        return {
            series: [],
            chartOptions: {
                labels: [],
                legend: {
                    position: 'bottom',
                    formatter: function (val, opts) {
                        return val + " - " + opts.w.globals.series[opts.seriesIndex]
                    }
                },
                chart: {
                    type: 'pie',
                },
                dataLabels: {
                    enabled: false
                },
                colors: ['#2A9D8F', '#264653', '#ED8936'],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'light',
                        type: 'horizontal',
                        shadeIntensity: 0.5,
                        gradientToColors: undefined,
                        inverseColors: true,
                        opacityFrom: 0.7,
                        opacityTo: 1,
                        stops: [0, 100]
                    }
                },
            },
        };
    },
    watch: {
        data: {
            handler(newData) {

                if (!Array.isArray(newData)) return;

                const labels = newData.map(item => item.label);
                const values = newData.map(item => item.count);

                this.chartOptions = {
                    ...this.chartOptions,
                    labels: labels,
                };
                this.series = values;
            },
            immediate: true,
            deep: true,
        },
    },
}
</script>